<div class="catalog-page">

    <h1 class="page-title">
        {{ categorySlug }}
    </h1>

    <p *ngIf="loading" class="loading">
        Loading products...
    </p>

    <div
        class="products-grid"
        *ngIf="!loading">

        <a
            class="product-card"
            *ngFor="let product of products"
            [routerLink]="['/product', product.slug]">

            <img
                *ngIf="product.mainImage"
                class="product-image"
                [src]="product.mainImage"
                [alt]="product.name">

            <div class="overlay">

                <h3>
                    {{ product.name }}
                    {{ product.description }}
                </h3>
                
                <div class="card-footer">

                    <span>POGLEDAJ DETALJE</span>

                </div>

            </div>

        </a>

    </div>

</div>